import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

//- The System area has no permission flag of its own. The left drawer only shows it to
//- employees, and the APIs behind it declare no allowRoles, which makes them employee-only
//- too -- so the gate is the role, in both places.
const mapStateToProps = (state) => {
	return {
		accessToken: state.auth.accessToken,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
